import { useQueryClient } from '@tanstack/react-query';

export const useQueryInvalidation = () => {
  const queryClient = useQueryClient();

  const invalidateAll = () => {
    // Invalidar todas as queries relacionadas ao dashboard e listagens
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
    queryClient.invalidateQueries({ queryKey: ['alunos'] });
    queryClient.invalidateQueries({ queryKey: ['empresas'] });
    queryClient.invalidateQueries({ queryKey: ['cidades'] });
    queryClient.invalidateQueries({ queryKey: ['cursos'] });
    queryClient.invalidateQueries({ queryKey: ['instituicoes'] });
    queryClient.invalidateQueries({ queryKey: ['seguradoras'] });
    queryClient.invalidateQueries({ queryKey: ['estagios'] });
    queryClient.invalidateQueries({ queryKey: ['relatorios'] });
  };

  const invalidateAlunos = () => {
    queryClient.invalidateQueries({ queryKey: ['alunos'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  const invalidateEmpresas = () => {
    queryClient.invalidateQueries({ queryKey: ['empresas'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  const invalidateCidades = () => {
    queryClient.invalidateQueries({ queryKey: ['cidades'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  const invalidateCursos = () => {
    queryClient.invalidateQueries({ queryKey: ['cursos'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  const invalidateInstituicoes = () => {
    queryClient.invalidateQueries({ queryKey: ['instituicoes'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  const invalidateSeguradoras = () => {
    queryClient.invalidateQueries({ queryKey: ['seguradoras'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  const invalidateEstagios = () => {
    queryClient.invalidateQueries({ queryKey: ['estagios'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
    queryClient.invalidateQueries({ queryKey: ['estagios-recentes'] });
  };

  const invalidateRelatorios = () => {
    queryClient.invalidateQueries({ queryKey: ['relatorios'] });
    queryClient.invalidateQueries({ queryKey: ['dashboard-stats'] });
  };

  return {
    invalidateAll,
    invalidateAlunos,
    invalidateEmpresas,
    invalidateCidades,
    invalidateCursos,
    invalidateInstituicoes,
    invalidateSeguradoras,
    invalidateEstagios,
    invalidateRelatorios,
  };
};
